import React from 'react'
import { Box } from '@mui/material'
import ViaggiForm from './ViaggiForm'
import { useSelector } from 'react-redux'
export const ViaggiSlider = ({cantine, setCantine}) => {
    const singleData = useSelector((state) => state.trasporto?.singleTrasport)
    return (
        <Box className='customDrawer_container'>
            <Box className='boxContainer__head'>
                <h2 className="boxContainer__title">Registra un Viaggio</h2>
            </Box>
           <ViaggiForm cantine={cantine} setCantine={setCantine} singleData={singleData}/>
        </Box>
    )
}
